var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { getOutgoingMessages, getOutgoingMessagesData } from "../../store/actions/response.actions";
import { connect } from "../../store/connect";
import get from "lodash/get";
import { LoaderState } from "../../store/actions/loader.actions";
import { API_METHODS_ENUM } from "../../httpService";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { getBookManager } from "../../models/BookModel";
import { useTranslation } from "react-i18next";
import { Messages } from "./Messages";
var outgoingMessageFactory = function () {
    /**
     *
     * Messages page
     * Show all messages created for the current booking.
     *
     */
    var OutgoingMessagesPage = function (props) {
        var t = useTranslation().t;
        var queryString = props.queryString, getOutgoingMessages = props.getOutgoingMessages;
        React.useEffect(function () {
            getOutgoingMessages(queryString);
        }, []);
        var title = t("outgoing_messages.title");
        return React.createElement(Messages, { messages: props.outgoingMessages, title: title });
    };
    /**
     *
     * Adding props from state
     *
     */
    var mapStateToProps = function (state) {
        return {
            isLoading: new LoaderState(state.loaderReducer, { keys: [API_METHODS_ENUM.GET_OUTGOING_MESSAGES] }).isLoading(),
            outgoingMessagesResponse: get(getOutgoingMessagesData(state.responseReducer), "response"),
        };
    };
    /**
     *
     * fetching outgoing messages from state
     *
     */
    var mergedProps = function (_a, dispatch, ownProps) {
        var otherargs = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            otherargs[_i - 3] = arguments[_i];
        }
        var outgoingMessagesResponse = _a.outgoingMessagesResponse, props = __rest(_a, ["outgoingMessagesResponse"]);
        var outgoingMessageEntities = outgoingMessagesResponse && getResponseManager(outgoingMessagesResponse).outgoingMessages();
        var mergedProps = __assign(__assign(__assign(__assign(__assign({}, props), dispatch), ownProps), otherargs), { outgoingMessages: [] });
        if (outgoingMessageEntities) {
            mergedProps.outgoingMessages = getBookManager(outgoingMessageEntities).outgoingMessages().all();
        }
        return mergedProps;
    };
    return connect(mapStateToProps, { getOutgoingMessages: getOutgoingMessages }, mergedProps)(OutgoingMessagesPage);
};
export var OutgoingMessagesPage = outgoingMessageFactory();
